import { createFileRoute } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { RegionsList } from '@/features/organizations/settings/regions'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/regions'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: RegionsPage,
})

function RegionsPage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()

  if (isPending) {
    return (
      <Main>
        <div className='py-8 text-center'>
          <p className='text-muted-foreground'>Loading organization...</p>
        </div>
      </Main>
    )
  }

  return <RegionsList organizationId={activeOrganization?.id || ''} />
}
